export enum GetterTypes {
  GET_LOADING_STATUS = "GET_LOADING_STATUS",
  GET_CSRF_INFORMATION = "GET_CSRF_INFORMATION",
  GET_BANNER_STATUS = "GET_BANNER_STATUS",
  GET_DIALOG_STATUS = "GET_DIALOG_STATUS",
  GET_NOTIFICATION_STATUS = "GET_NOTIFICATION_STATUS",
  GET_ALERT_STATUS = "GET_ALERT_STATUS"
}
